import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, commonIdGetStripeCheckoutUrlFeatureKey } from '../../reducers/common-id/common-id-get-stripe-checkout-url.reducer';

const selectCommonIdGetStripeCheckoutUrlState = createFeatureSelector<State>(commonIdGetStripeCheckoutUrlFeatureKey);

export const getStripeCheckoutUrl = createSelector(
  selectCommonIdGetStripeCheckoutUrlState,
  state => state.commonIdGetStripeCheckoutUrlResult
);
